import type { PageContextType } from ".";
import React from "react";

export const PageContext = React.createContext<PageContextType>({} as PageContextType)